import { render, staticRenderFns } from "./About.vue?vue&type=template&id=d2078284&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
import style0 from "./About.vue?vue&type=style&index=0&id=d2078284&prod&lang=css"
import style1 from "./About.vue?vue&type=style&index=1&id=d2078284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2078284",
  null
  
)

export default component.exports